var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemTable',{attrs:{"title":"特別","headers":_vm.specialIndicateHeaders,"items":_vm.items,"item_class":_vm.specialIndicateRowBackground},on:{"makenew":_vm.toSpecialEdit,"repair":_vm.toSpecialEditRepair,"copy":_vm.toSpecialEditCopy}})}
var staticRenderFns = []

export { render, staticRenderFns }